<!-- 方案加价审核 -->
<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('Pricing.Audit')"
    width="1000px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="price-dialog"
  >
    <div class="price-dialog-header">
      <div>
        <el-button no="onOK" type="primary" @click="onOK">{{ $t('Pricing.CONFIRM') }}</el-button>
        <el-button no="onCancel" @click="onCancel">{{ $t('Pricing.Back') }}</el-button>
      </div>
    </div>
    <div style="margin: 10px">
      <el-checkbox no="tier1" label="Tier 1" :disabled="true" checked />
      <el-checkbox no="tier2" label="Tier 2" :disabled="true" checked />
      <el-checkbox no="tier3" label="Tier 3" :disabled="true" checked />
    </div>
    <markup-air-data-grid
      style="margin-top:10px;"
      :row-data="rowData"
      :editable="false"
      :grid-options="gridOptions"
    />
  </el-dialog>
</template>

<script>

import MarkupAirDataGrid from '@/views/cargo/v0/Price/PriceAir/components/markupAirDataGrid'
import { AirApproveSettings } from '@/views/cargo/v0/Price/PriceAir/components/airApproveSettings'
import { approvePriceAirsWithAllTiers } from '@/api/price/priceAir'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import { getLoading } from '@/utils/utilBaseElement'
import { getFilterCacheList } from '@/utils/basicDataCache'
import { cacheKeys } from '@/utils/basicDataCache'
export default {
  name: 'FclMarkupSchemeDialog',
  components: { MarkupAirDataGrid },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    selectedRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      PriceUtils,
      fullscreenLoading: null,
      rowData: [],
      cfg: {},
      source: null,
      airConfigUtil: null,
      markupSelectRow: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        // 单击显示编辑
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridSelectEditor,
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonInputEditor
        },
        onSelectionChanged: (event) => {
          this.markupSelectRow = event.api.getSelectedRows()
        }
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  methods: {
    init(airConfigUtil) {
      this.markupSelectRow = null
      this.airConfigUtil = airConfigUtil
      if (this.airConfigUtil['_isMarkupSettingsLoaded']) {
        this.onSettingsLoaded()
      }
      this.setData()
    },
    onSettingsLoaded() {
      this.cfg = this.airConfigUtil.markupCfg
      if (this.cfg === null) {
        if (this.airConfigUtil.markupCfgDef) {
          this.cfg = {}
          this.airConfigUtil.markupCfg = this.cfg
          if (this.airConfigUtil.isHQManager()) {
            this.cfg.officeId = 1
          } else {
            this.cfg.officeId = this.$store.getters.currentOfficeId
          }
          this.cfg.isOverrideable = false
          this.cfg.configId = this.airConfigUtil.markupCfgDef.configId
        } else {
          this.$message.warning(this.$t('Pricing.NoSetting'))
          return
        }
      }
      this.decodeSetting()
    },
    decodeSetting() {
      if (this.airConfigUtil.markupCfg) {
        const cfg = this.airConfigUtil.markupCfgValue['setting']
        const sources = []
        cfg.forEach(item => {
          sources.push(new AirApproveSettings(item))
        })
        this.source = sources
      } else {
        this.source = []
      }
    },
    setData() {
      if (this.source) {
        const gridProvider = []
        for (const cfg of this.source) { // 配置的方案
          for (const pf of this.selectedRows) { // 选中的运价
            if (this.isOverlap(cfg, pf)) {
              gridProvider.push(cfg)
              break
            }
          }
        }
        this.rowData = gridProvider
      }
    },
    isOverlap(cfg, pf) {
      let region = ''
      if (pf && pf.pod) {
        const ports = getFilterCacheList(cacheKeys.basic_data_Airport, (item) => { return item.code === pf.pod })
        if (ports && ports.length > 0) {
          region = ports[0].region
        }
      }
      if (cfg.carrier !== 0 && cfg.carrier !== 'ALLRG' && cfg.carrier !== pf.carrier) {
        return false
      }
      if (cfg.region !== 'ALLRG' && cfg.region !== region) {
        return false
      }
      if (cfg.pol !== pf.pol && cfg.pol !== 'ALLRG') {
        return false
      }
      if (cfg.pod !== pf.pod && cfg.pod !== 'ALLRG') {
        return false
      }
      if (!(cfg.frequency === 0 || this.PriceUtils.isFrequency(pf).search(cfg.frequency) > -1)) {
        return false
      }
      return true
    },
    onOK() {
      const { markupSelectRow } = this
      if (!markupSelectRow) {
        this.$message.warning(this.$t('Pricing.PlsSelectRule'))
        return
      }
      if (markupSelectRow.length > 1) {
        this.$message.warning(this.$t('SeaExport.SelectAPieceOfData'))
        return
      }
      const markups1 = [markupSelectRow[0].t1M, markupSelectRow[0].t1N, markupSelectRow[0].t1P45, markupSelectRow[0].t1P100, markupSelectRow[0].t1P300, markupSelectRow[0].t1P500, markupSelectRow[0].t1P1000]
      const markups2 = [markupSelectRow[0].t2M, markupSelectRow[0].t2N, markupSelectRow[0].t2P45, markupSelectRow[0].t2P100, markupSelectRow[0].t2P300, markupSelectRow[0].t2P500, markupSelectRow[0].t2P1000]
      const markups3 = [markupSelectRow[0].t3M, markupSelectRow[0].t3N, markupSelectRow[0].t3P45, markupSelectRow[0].t3P100, markupSelectRow[0].t3P300, markupSelectRow[0].t3P500, markupSelectRow[0].t3P1000]
      for (let i = 0; i < 6; i++) {
        const m1 = Number(markups1[i])
        const m2 = Number(markups2[i])
        const m3 = Number(markups3[i])
        if (m2 < m1) {
          this.$message.warning(this.$t('Pricing.Two_B_One'))
          return
        }
        if (m3 < m2) {
          this.$message.warning(this.$t('Pricing.Three_BE_Two'))
          return
        }
      }
      const uuids = []
      this.selectedRows.forEach(item => {
        if (this.isOverlap(markupSelectRow[0], item)) {
          uuids.push(item.uuid)
        }
      })
      const params = {
        priceAirUuids: uuids,
        isDefaultMarkup: false,
        markups_tier1: markups1,
        markups_tier2: markups2,
        markups_tier3: markups3
      }
      this.fullscreenLoading = getLoading()
      approvePriceAirsWithAllTiers(params).then(res => {
        this.$message.success(this.$t('Pricing.SchemeAudit') + this.$t('Message.Success'))
        this.$emit('close')
        this.$emit('auditBack', this.selectedRows)
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    onCancel() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
</style>
